import type { PropsWithChildren } from "react";
import { cn } from "#/lib/utils";

export function TradePanel({
	className,
	children,
}: PropsWithChildren<{ className?: string }>) {
	return (
		<section
			className={cn(
				"flex h-full min-h-0 w-full flex-col border border-trade-border-subtle bg-trade-surface",
				className,
			)}
		>
			{children}
		</section>
	);
}
